module.exports = __webpack_public_path__ + "static/media/m2cr44.d4809296.png";